module.exports = __webpack_public_path__ + "img/pic2.04613e3c.png";